var Model = require("../types/Model.js");

module.exports = new Model({
	name: "callgroupsmembers",
	init: init,
	listeners: listeners,

	recalculate: recalculate
});

function init(){
	this._groups = null;

	this.push(null);
}

function listeners(){
	return {
		"callgroups:updated": Model.makeRecalculator("rawGroups"),
		"incall:updated": Model.makeRecalculator("incall"),
		"availability:updated": Model.makeRecalculator("available")
	};
}

function recalculate(){
	var groups = this._rawGroups;
	var incall = this._incall;
	var available = this._available;

	if(!groups || !incall || !available) return;

	var newGroups = groups.reduce(function(acc, element){
		var unavailableCount = 0;
		var inCallCount = 0;
		var members = element.members;
		var personalId = this.config.id;
		var isInGroup = 0;

		var availableMembers = members.filter(function(member){
			var id = member;
			var returnValue = true;

			if(id === personalId){
				isInGroup = 1;
				return false;
			}

			var memberInCall = incall[id];
			if(memberInCall){
				inCallCount++;
				returnValue = false;
			}

			var memberAvailable = available[id];
			if(!memberAvailable){
				unavailableCount++;
				returnValue = false;
			}

			return returnValue;
		});

		var membersInfo = {
			available: (members.length - isInGroup) - unavailableCount,
			nonBusy: (members.length - isInGroup) - inCallCount
		};

		availableMembers.unshift(membersInfo);
		acc[element._id] = availableMembers;
		return acc;
	}.bind(this), {});

	this._groups = newGroups;
	this.push(newGroups);
}